class CmWowContent extends HTMLElement {
  async connectedCallback() {
    if (this.dataset.ready) return;
    const source = this.querySelector('.cm-wow-source');
    const images = [...(source?.querySelectorAll('img') || [])];
    // Decorative separators may precede the guild artwork in Shopify content.
    // Load dimensions before choosing the artwork, rather than taking the first image.
    await Promise.all(images.map(img => {
      img.loading = 'eager';
      return img.decode().catch(() => {});
    }));
    if (!this.isConnected || this.dataset.ready) return;
    const area = img => (img.naturalWidth || img.width || 0) * (img.naturalHeight || img.height || 0);
    const originalImage = images.sort((a, b) => area(b) - area(a))[0];
    if (!originalImage) return;
    this.dataset.ready = 'true';
    const media = document.createElement('div');
    media.className = 'cm-wow-media';
    const copy = document.createElement('div');
    copy.className = 'cm-wow-copy rte';
    // Preserve the original image, link, text and any additional media.
    let visual = originalImage.closest('picture') || originalImage;
    const imageLink = visual.closest('a');
    if (imageLink && !imageLink.textContent.trim() && imageLink.querySelectorAll('img').length === 1) visual = imageLink;
    media.append(visual);
    while (source.firstChild) copy.append(source.firstChild);
    // The legacy content includes ornamental image dividers and horizontal rules.
    for (const img of copy.querySelectorAll('img')) {
      const width = img.naturalWidth || img.width;
      const height = img.naturalHeight || img.height;
      if (height && width / height > 8) img.remove();
    }
    copy.querySelectorAll('hr').forEach(rule => rule.remove());
    for (const p of copy.querySelectorAll('p')) {
      if (!p.textContent.trim() && !p.querySelector('img,video,iframe,svg,input')) p.remove();
    }
    for (const element of [...copy.querySelectorAll('div,span,p,a')].reverse()) {
      if (!element.textContent.trim() && !element.querySelector('img,video,iframe,svg,input')) element.remove();
    }
    source.replaceWith(media, copy);
    const main = this.closest('main');
    const background = this.dataset.background || originalImage.currentSrc || originalImage.src;
    if (main && background) main.style.setProperty('--cm-wow-background', `url(${JSON.stringify(background)})`);
  }
}
if (!customElements.get('cm-wow-content')) customElements.define('cm-wow-content', CmWowContent);
